import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Row } from 'react-bootstrap'
import _ from 'underscore'
import { reduxForm, touch, Field } from 'redux-form'
import Input from './../../../components/Input'
import { configuration } from '../../../configuration'
import { FormGroup, FormControl } from 'react-bootstrap'
import validation from './../../../constants/validation'
import { switchCheckoutContent } from './../checkoutContent/actions'
import Checkbox from '../../../components/Checkbox'

import './styles.css'
import '../../../styles/form.css'
const { REQUIRED_FIELD } = validation

const validate = values => {
  const validateEmail = (email) => {
    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
  }

  const validatePhone = (phone) => {
    let re = /^[0-9]{9}$/
    return re.test(phone)
  }

  const textContainsNumbers = (text) => {
    return /\d/.test(text);
  }

  const errors = {}
  if (!values.clientEmail || values.clientEmail === "" || !validateEmail(values.clientEmail)) {
    errors.clientEmail = REQUIRED_FIELD
    if (!validateEmail(values.clientEmail)) {
      errors.clientEmail = 'Debe introducir un correo válido'
    }
  }
  if (!values.clientPhone || values.clientPhone === "" || !validatePhone(values.clientPhone)) {
    errors.clientPhone = REQUIRED_FIELD
    if (!validatePhone(values.clientPhone)) {
      errors.clientPhone = 'Debe introducir un teléfono válido'
    }
  }
  if (!values.clientName || values.clientName === "" || textContainsNumbers(values.clientName)) {
    errors.clientName = REQUIRED_FIELD
    if (textContainsNumbers) {
      errors.clientName = 'El nombre solo debe contener caracteres'
    }
  }
  if (!values.clientSurname || values.clientSurname === "" || textContainsNumbers(values.clientSurname)) {
    errors.clientSurname = REQUIRED_FIELD
    if (textContainsNumbers) {
      errors.clientSurname = 'El apellido solo debe contener caracteres'
    }
  }
  if (!values.RGPDcheck1) {
    errors.RGPDcheck1 = REQUIRED_FIELD
  }
  if (!values.RGPDcheck2) {
    errors.RGPDcheck2 = REQUIRED_FIELD
  }
  return errors;
}

const form = reduxForm({
  form: 'personalDataForm',
  validate,
})

// Render components
const renderInputField = (field) => {
  return (
    <span>
      <FormControl {...field.input} disabled={field.disabled} componentClass={field.componentClass || 'input'}>
        {field.children || ''};
      </FormControl>
      {field.meta.touched && ((field.meta.error && <span className="text-danger">{field.meta.error}</span>) || (field.meta.warning && <span className="text-warning">{field.meta.warning}</span>))}
    </span>
  );
}

class ClientRegistration extends React.Component {

  static propTypes = {
    submitBudgetData: PropTypes.func.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    personalDataForm: PropTypes.shape({
      values: PropTypes.object
    }).isRequired,
  }

  state = {
    currentUser: null,
    submitSended: false
  }

  componentWillReceiveProps(props) {
    if (props.checkoutContentStore.currentUser !== null) {
      this.setState({
        currentUser: props.checkoutContentStore.currentUser.user,
      })
    }
  }

  //Controlar aqui que se añade el vehiculo de sustitucion
  handleFormSubmit(values) {
    // Deshabilitamos el botón.
    this.setState({ submitSended: true })

    if (this.props.personalDataForm.syncErrors) {
      _.each(Object.keys(this.props.personalDataForm.syncErrors), (field) => {
        this.props.touchFormField('personalDataForm', field);
      });
    }
    this.props.submitBudgetData()
  }

  handleBack() {
    if (this.props.appointmentStore.beforeBudget) {
      this.props.switchCheckoutContent('appointment')
    } else {
      this.props.switchCheckoutContent('services')
    }

  }

  render() {
    let renderContent = '';
    const currentUser = this.state.currentUser;
    const { handleSubmit } = this.props;

    if (currentUser && !configuration().mandatoryClientData) {
      renderContent = (
        <div>
          <span className="hello-user">Hola <span className="hello-user-name">{currentUser.firstName}</span> ya tenemos tus datos de contacto, por favor, valida tu email.</span>
          <br /><br />
          <Row>
            <FormGroup bsClass="col-12 " controlId="clientEmail">
              <Field bsClass="name-rectangle" component={Input} name="clientEmail" type="email" placeholder="Email (Ej. hola@bubocar.com)" />
            </FormGroup>
            <span className="col-12 subtext-email">No compartiremos su correo electrónico con nadie.</span>
          </Row>
        </div>
      );

    } else {
      renderContent = (
        <div>
          <Row>
            <FormGroup bsClass="col-12 col-md-6" controlId="clientName">
              <Field bsClass="name-rectangle" component={Input} name="clientName" type="text" label={configuration().inputWithoutPlaceHolder ? 'Nombre' : null} placeholder={configuration().inputWithoutPlaceHolder ? null : 'Nombre'} brand={configuration().clientName} />
            </FormGroup>
            <FormGroup bsClass="col-12 col-md-6" controlId="clientSurname">
              <Field bsClass="name-rectangle" component={Input} name="clientSurname" type="text" label={configuration().inputWithoutPlaceHolder ? 'Apellidos' : null} placeholder={configuration().inputWithoutPlaceHolder ? null : 'Apellidos'} />
            </FormGroup>
          </Row>
          <Row>
            <FormGroup bsClass="col-12 " controlId="clientEmail">
              <Field bsClass="name-rectangle" component={Input} name="clientEmail" type="email" label={configuration().inputWithoutPlaceHolder ? 'Email' : null} placeholder={configuration().inputWithoutPlaceHolder ? null : 'Email'} />
            </FormGroup>
            <span className="col-12 subtext-email">No compartiremos su correo electrónico con nadie.</span>
          </Row>
          <br />
          <Row>
            <FormGroup bsClass="col-12" controlId="clientPhone">
              <Field bsClass="name-rectangle" component={Input} name="clientPhone" type="number" label={configuration().inputWithoutPlaceHolder ? 'Número de teléfono' : null} placeholder={configuration().inputWithoutPlaceHolder ? null : 'Número de teléfono'} />
            </FormGroup>
          </Row>
          {
            configuration().rgpdCheck1
              ? <Row>
                <FormGroup bsClass="col-12" controlId="RGPDcheck1">
                  <Field name='RGPDcheck1' className="form-group form-item-flex" {...configuration().rgpdCheck1} component={Checkbox} />
                </FormGroup>
              </Row>
              : null
          }
          {
            configuration().rgpdCheck2
              ? <Row>
                <FormGroup bsClass="col-12" controlId="RGPDcheck2">
                  <Field name='RGPDcheck2' className="form-group form-item-flex" {...configuration().rgpdCheck2} component={Checkbox} />
                </FormGroup>
              </Row>
              : null
          }
        </div>
      );
    }

    const submitButtonStyles = {
      backgroundColor: configuration().clientColor,
      borderColor: configuration().clientColor,
      color: configuration().btnColor ? configuration().btnColor : ''
    }

    const propsButtonSend = this.state.submitSended ? { "disabled": "disabled" } : {}

    return (
      <form >
        {renderContent}
        <br />
        <Row>
          <div className="col-12 col-md-4">
            <button className=" responsivebutton jump pull-left button-secondary router-buttons" onClick={() => { this.handleBack() }} >{configuration().arrowInButon ? <i className="fa fa-angle-left" aria-hidden="true"></i> : ''}
              <span className="labelFlip1">ATRÁS</span>
              <span className="labelFlip2" style={{ visibility: 'hidden' }}>ATRÁS</span>
            </button>
          </div>
          <div className="col-12 col-md-4 offset-md-4">
            <button className=" responsivebutton jump button-enviar" style={submitButtonStyles}
              onClick={handleSubmit(this.handleFormSubmit.bind(this))}
              {...propsButtonSend}
            >
              <span className="labelFlip1" style={{ fontSize: 18, color: submitButtonStyles.color }}>
                ENVIAR
              </span>
              <span className="labelFlip2" style={{ visibility: 'hidden' }}>
                ENVIAR
              </span>
            </button>
          </div>
        </Row>
      </form>
    );
  }
}

const mapStateToProps = state => ({
  appointmentStore: state.checkout.appointment,
  clientRegistrationStore: state.checkout.clientRegistration,
  checkoutContentStore: state.checkout.checkoutContent,
  checkoutStore: state.checkout.checkoutRoot,
  shoppingCart: state.checkout.shoppingCart,
  personalDataForm: state.form.personalDataForm || {},
});

const bindActions = dispatch => ({
  touchFormField: (form, field) => dispatch(touch(form, field)),
  switchCheckoutContent: content => dispatch(switchCheckoutContent(content)),
});

export default connect(mapStateToProps, bindActions)(form(ClientRegistration));



// WEBPACK FOOTER //
// ./src/workflow/checkout/clientRegistration/index.js